export default __webpack_public_path__ + "static/media/img6.257e4a68.jpg";